import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { createApi } from "./api";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { config } from "./config";
import { installErrorReporting } from "./errorReport";
import { captureRef } from "./referral";
import { readLocal } from "./storage";
import { turnstileTokenGetter } from "./turnstile";
import "./styles.css";

captureRef(); // a friend's link /?ref=<code>: kept 30 days for the next sign-in, removed from the address (referral.ts)

// dev sign-in only (server IDSERVER_AUTH_MODE=dev): ?user=<name> or localStorage "idphoto.devUser"; ?guest=1 starts
// signed out (as a visitor of the real site does) and the sign-in dialog asks for a name
const params = new URLSearchParams(window.location.search);
const devUser = params.has("guest") ? null : params.get("user") ?? readLocal("idphoto.devUser") ?? "web-dev";

const api = createApi({
  base: config.apiBase,
  authMode: config.authMode,
  devUser: () => devUser,
  turnstile: turnstileTokenGetter(config.turnstileSiteKey),
});

// v4 item 8: uncaught errors → the server's log (≤ 5 per page load, path only); the boundary below reports React's
const reportError = installErrorReporting(api.clientError);

// /admin: the operator's account manager, in its own chunk (visitors never download it)
const AdminApp = lazy(() => import("./admin/AdminApp").then((m) => ({ default: m.AdminApp })));
const isAdmin = window.location.pathname.replace(/\/+$/, "") === "/admin";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary onError={(error, componentStack) => reportError("react", error, componentStack)}>
    {isAdmin ? (
      <Suspense fallback={<p className="hint">Đang tải…</p>}><AdminApp api={api} devUser={devUser} /></Suspense>
    ) : (
      // "/" and "/chinh-anh": one page, the mode from the address (App.modeFromLocation)
      <App api={api} devUser={devUser} />
    )}
    </ErrorBoundary>
  </StrictMode>,
);
